import { Slide, IconButton, Typography } from "@mui/material";
import { Box } from "@mui/system";
import dayjs from "dayjs";
import React from "react";
import { defaultColorPallete, copyToClipboard } from "utils";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import { formatMessage } from "components/Chat/ChatMessages/utils";

type Props = {
  conversationSummary: {
    from: string;
    summary: string;
    to: string;
    totalMessages: number;
  } | null;
  closeConversationSummary: () => void;
};

const ConversationSummary: React.FC<Props> = React.memo(
  function ConversationSummary(props) {
    const { conversationSummary, closeConversationSummary } = props;

    return (
      <Slide
        direction="left"
        in={!!conversationSummary}
        mountOnEnter
        unmountOnExit
      >
        <Box
          id={"conversationSummary"}
          height={"100%"}
          width={{ xs: "100%", lg: "20%" }}
          p={2}
        >
          <Box pt={{ xs: 0, sm: 4 }}>
            <IconButton>
              <HighlightOffIcon
                onClick={closeConversationSummary}
                fontSize="large"
                sx={{ color: defaultColorPallete.primary.main }}
              />
            </IconButton>
            <Box gap={1} mb={2} ml={1}>
              <Box display="flex" alignItems="center">
                <Typography color="primary" fontWeight="600" fontSize={18}>
                  Resumo da conversa
                </Typography>
                <IconButton
                  onClick={() => copyToClipboard(conversationSummary?.summary)}
                  title="Copiar resumo"
                >
                  <ContentCopyIcon
                    fontSize="small"
                    sx={{ color: defaultColorPallete.neutral.main }}
                  />
                </IconButton>
              </Box>
              {conversationSummary?.from && (
                <Typography variant="caption" color="primary" fontWeight="200">
                  A partir do dia{" "}
                  {dayjs(conversationSummary?.from).format("DD/MM/YYYY")}
                </Typography>
              )}
            </Box>
            <Box p={2} overflow="auto" height="600px">
              <Typography variant="body2">
                {formatMessage(conversationSummary?.summary)}
              </Typography>
            </Box>
          </Box>
        </Box>
      </Slide>
    );
  }
);

export default ConversationSummary;
